import promotions from "./promotions.component";
import promotionsUrls from "./promotions.urls";
import PromotionsTransforms from "./promotions.transforms";

const promotionsModule = angular
  .module("app.components.promotions", [])
  .component("promotionsPage", promotions)
  .service("PromotionsTransforms", PromotionsTransforms)
  .config(promotionsUrls);

export default promotionsModule;



// WEBPACK FOOTER //
// ./src/pages/promotions/promotions.module.js